module.exports = __webpack_public_path__ + "img/preview-4.1ecf4a34.webp";